import React from "react";

import DonutChart from "../charts/DonutChart";
import TicketVolumeChart from "../charts/TicketVolumeChart";
import ChartCard from "../shared/ChartCard";
import KPICard from "../shared/KPICard";
import KPICardGrid from "../shared/KPICardGrid";

const SupportTab = ({ data, loading }) => (
  <div className="space-y-6">
    {/* KPI Cards */}
    <KPICardGrid>
      <KPICard
        color="bg-red-500"
        icon="fas fa-ticket-alt"
        index={0}
        label="Open Tickets"
        loading={loading}
        value={data.tickets.open}
      />
      <KPICard
        color="bg-blue-500"
        icon="fas fa-clock"
        index={1}
        label="Avg Resolution Time"
        loading={loading}
        value={data.tickets.avgResolutionTime}
      />
      <KPICard
        color="bg-yellow-500"
        icon="fas fa-star"
        index={2}
        label="Customer Satisfaction"
        loading={loading}
        value={data.tickets.satisfaction}
      />
      <KPICard
        color="bg-green-500"
        icon="fas fa-bolt"
        index={3}
        label="First Response Time"
        loading={loading}
        value={data.tickets.firstResponseTime}
      />
    </KPICardGrid>

    {/* Ticket Volume */}
    <ChartCard loading={loading} title="Ticket Volume">
      <TicketVolumeChart
        categories={data.tickets.volume.categories}
        data={data.tickets.volume.data}
        height={350}
      />
    </ChartCard>

    {/* Bottom 2-column grid */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
      {/* Ticket Categories */}
      <ChartCard loading={loading} title="Ticket Categories">
        <DonutChart
          height={300}
          labels={["Open", "Customer Replied", "Answered", "Closed"]}
          series={Object.values(data.tickets.byStatus)}
        />
      </ChartCard>

      {/* Agent Performance */}
      <ChartCard loading={loading} title="Agent Performance">
        <div className="space-y-3">
          {data.tickets.agents.map((agent, index) => (
            <div
              className="flex items-center justify-between p-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700"
              key={index}
            >
              <div className="flex items-center gap-3">
                {agent.avatarUrl ? (
                  <img
                    alt={agent.name}
                    className="w-10 h-10 rounded-full object-cover"
                    src={agent.avatarUrl}
                  />
                ) : (
                  <div className="w-10 h-10 bg-gradient-to-br from-primary-400 to-primary-600 rounded-full flex items-center justify-center text-white font-semibold">
                    {agent.name
                      .split(" ")
                      .map((n) => n[0])
                      .join("")}
                  </div>
                )}
                <div>
                  <p className="font-medium text-gray-900 dark:text-white">
                    {agent.name}
                  </p>
                  <p className="text-sm text-gray-500 dark:text-gray-400">
                    {agent.tickets} tickets assigned
                    {agent.closed > 0 && ` · ${agent.closed} closed`}
                  </p>
                </div>
              </div>
              <div className="text-right">
                <div className="flex items-center gap-1">
                  <i className="fas fa-star text-yellow-500 text-sm" />
                  <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                    {agent.satisfaction}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </ChartCard>
    </div>
  </div>
);

export default SupportTab;
